module.exports = __webpack_public_path__ + "createstatic/media/closeBtn.5e5d4bfb.svg";